<div class="sidebar-candidate-documents"><app-loading [isLoading]="isLoading">
  @if (documents.length === 0) {
    <p class="text-muted">{{ 'SIDEBAR.DOCUMENTS.EMPTY' | translate }}</p>
  }
  @if (isSupportMode) {
    <div class="alert alert-info small" role="status" data-testid="documents-support-mode-note"><strong>{{ 'CANDIDATE_DOCUMENTS.SUPPORT_MODE' | translate }}</strong> {{ 'CANDIDATE_DOCUMENTS.SUPPORT_MODE_HINT' | translate }}</div>
  }
  <ul class="list-group">
    @for (d of documents; track d.id) {
      <li class="list-group-item d-flex align-items-center justify-content-between">
        <span><i class="lnr lnr-paperclip me-2" aria-hidden="true"></i>{{ d.filename }}
          @if (d.quarantined) {
            <span class="badge bg-danger ms-2" title="{{ 'CANDIDATE_DOCUMENTS.QUARANTINED_HINT' | translate }}">{{ 'CANDIDATE_DOCUMENTS.QUARANTINED' | translate }}</span>
          }
          @if (d.uploaded_by) {
            <small class="text-muted d-block">{{ 'SIDEBAR.DOCUMENTS.UPLOADED_BY' | translate: { name: d.uploaded_by } }}</small>
          }
        </span>
        <span class="text-muted small me-2">{{ d.created_at | date: 'mediumDate' }}</span>
        @if (!d.quarantined && !isSupportMode) {
          <button class="btn btn-sm btn-link" type="button" [disabled]="d.isDownloading" (click)="download(d)">{{ 'SIDEBAR.DOCUMENTS.DOWNLOAD' | translate }}</button>
        }
      </li>
    }
  </ul>
</app-loading></div>
